module.exports = __webpack_public_path__ + "img/special_anonymous.70ba9453.png";